<mat-card>
  <app-card-header
    [title]="'Servicios técnicos'"
    [subtitle]="dispositivoNombre"
    icono="build"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Sección: servicio técnico activo -->
    <app-content-card title="Servicio técnico activo" icon="engineering">
      <div class="etd-cuerpo">
        @if (eventoActivo) {
          <div class="evento-activo-info">
            <div class="etd-datos">
              <span class="etd-etiqueta">Estado</span>
              @if (estadoServicio(eventoActivo); as estado) {
                <span>
                  <span class="irx-estado irx-estado--{{ estado.tono }}">
                    @if (estado.icono) {
                      <mat-icon>{{ estado.icono }}</mat-icon>
                    }
                    {{ estado.texto }}
                  </span>
                </span>
              } @else {
                <span class="no-info">Sin estado</span>
              }

              <span class="etd-etiqueta">Título</span>
              @if (eventoActivo.valores?.titulo) {
                <span class="etd-valor">
                  {{ eventoActivo.valores?.titulo }}
                </span>
              } @else {
                <span class="no-info">Sin título</span>
              }

              <span class="etd-etiqueta">Fecha de creación</span>
              @if (eventoActivo.fechaCreacion) {
                <span class="etd-valor">
                  {{ fechaCelda(eventoActivo.fechaCreacion) }}
                  <span class="etd-hace">
                    · {{ haceCelda(eventoActivo.fechaCreacion) }}
                  </span>
                </span>
              } @else {
                <span class="no-info">Sin fecha</span>
              }

              <span class="etd-etiqueta">Técnico asignado</span>
              @let tecnico = eventoActivo?.detallesTecnicos?.tecnico;
              @if (tecnico) {
                <span class="etd-valor etd-tecnico">
                  @if (tecnico.datosPersonales?.foto) {
                    <img
                      class="avatar-circular"
                      [src]="tecnico.datosPersonales.foto"
                      alt="Foto del técnico"
                    />
                  }
                  {{ tecnico.datosPersonales?.nombre || tecnico.usuario }}
                </span>
              } @else {
                <span class="no-info">Sin técnico asignado</span>
              }
            </div>

            <div class="acciones-evento-activo">
              <button
                irxBoton="secundario"
                type="button"
                (click)="editar(eventoActivo)"
                [disabled]="
                  !helper.tienePermiso('Servicio Técnico - Editar solicitudes')
                "
                class="action-button"
              >
                <mat-icon>edit</mat-icon>
                Editar
              </button>

              <button
                irxBoton="secundario"
                type="button"
                (click)="asignar(eventoActivo)"
                [disabled]="
                  !helper.tienePermiso(
                    'Servicio Técnico - Reasignar solicitudes'
                  )
                "
                class="action-button"
              >
                <mat-icon>engineering</mat-icon>
                Asignar
              </button>

              <button
                irxBoton="principal"
                type="button"
                (click)="atender(eventoActivo)"
                [disabled]="
                  !helper.tienePermiso('Servicio Técnico - Atender solicitudes')
                "
                class="action-button"
              >
                <mat-icon>troubleshoot</mat-icon>
                Atender
              </button>
            </div>
          </div>
        } @else {
          <div class="sin-evento-activo">
            <mat-icon>info</mat-icon>
            <p>No hay servicios técnicos activos para este dispositivo</p>
            <button
              irxBoton="principal"
              type="button"
              (click)="crear()"
              [disabled]="
                !helper.tienePermiso('Servicio Técnico - Crear solicitudes')
              "
            >
              <mat-icon>add</mat-icon>
              <span>Crear servicio técnico</span>
            </button>
          </div>
        }
      </div>
    </app-content-card>

    <!-- Sección: historial -->
    <app-content-card title="Historial de servicios técnicos" icon="history">
      <div class="etd-cuerpo">
        @if (datosHistorial.length > 0) {
          <app-tabla
            [totalCount]="totalCountHistorial"
            [datos]="datosHistorial"
            [columnas]="columnasHistorial"
            [name]="name + '_historial'"
            [pageSizeOptions]="[10, 25, 50]"
            [search]="search"
            [(query)]="queryHistorial"
            (queryChange)="listarHistorial()"
            [paginatorArriba]="false"
            [filtros]="filtros"
          ></app-tabla>
        } @else {
          <div class="sin-historial">
            <mat-icon>history</mat-icon>
            <p>No hay historial de servicios técnicos finalizados</p>
          </div>
        }
      </div>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
